module.exports = __webpack_public_path__ + "static/media/change.b5deedb9.svg";